import { Box, Container, Typography } from '@mui/material';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import { getImageUrl } from '@/utils/get-image-url';

export const Banner = () => {
  const { bootstrap } = useBootstrapData();

  const company = bootstrap?.info?.colaborador?.empresa;

  return (
    <Box bgcolor={company?.primary_color} mt={6} py={4}>
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h1" color="neutral.0">
          {company?.corporate_university_name ?? 'Universidade Corporativa'}
        </Typography>
        {company?.logo && (
          <img
            src={getImageUrl(company?.logo)}
            alt="Logo da universidade corporativa"
            width={100}
          />
        )}
      </Container>
    </Box>
  );
};
